import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import {prepareData} from 'utils/googleData'


import {Heading2} from 'components/Heading';
import Button from 'components/Button';

import bg from './images/bg.svg';

import './get-started.css';
const LINKS = {docker: '/docs/on-premise', getStarted: '/docs/get-started'};

const TITLE = 'Ready to send your first notification?';

const LEFT_TITLE = 'On-Permiseed';
const LEFT_DESCRIPTION = 'Run locally with docker-compose';
const LEFT_BUTTON_TEXT = 'Read Docs';

const RIGHT_TITLE = 'Cloud';
const RIGHT_DESCRIPTION = 'Use our free managed service';
const RIGHT_BUTTON_TEXT = 'Get Started';

const themeClassNames = {
  pink: 'get-started-gradient-multicolor',
  blue: 'get-started-blue-gradient-multicolor',
};

export default function CTA2(props)  {

  const { id,enable,homeCTATitle,ctas,direction,gatsbyImage,gatsbyImage2}= prepareData({props})
      if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
  const {title,subtitle,description,leftTitle, leftDescription, leftButtonLink, leftButtonText, rightTitle, rightDescription, rightButtonLink, rightButtonText} = homeCTATitle
  const style1 = ctas?.[1]?.style || 'blue'
  const style0 = ctas?.[0]?.style || 'pink'
  return (
  <section className="get-started safe-paddings relative overflow-hidden py-40 lg:py-28 md:py-16 sm:py-11">
    <div className="lg:max-w-none md:px-7 sm:px-4; relative z-10">
      <Heading2 size="md" tag="h2" className="text-center leading-tight md:text-3xl" theme="white">
        {title}
      </Heading2>


      <div className="mx-auto lg:mt-16 grid max-w-[968px] md:grid-cols-2  lg:gap-x-7 md:mt-12 md:gap-x-5 sm:mt-8 grid-cols-1 gap-x-0 gap-y-7">
        <div
          className={clsx(
            'flex flex-col items-center rounded-[20px] bg-gradient-to-b from-gray-2 to-[rgba(26,26,26,0.7)] p-8 pb-10 lg:rounded-2xl sm:order-2 sm:p-5',
            themeClassNames[style0]
          )}
        >


          <Heading2
            size="sm"
            tag="h3"
            className="font-medium leading-snug sm:text-2xl"
            theme="white"
          >
            {leftTitle}
          </Heading2>
          <p className="mt-3 mb-7 text-center font-book leading-snug text-gray-9 sm:mb-5 sm:text-base">
            {leftDescription}
          </p>
          <Button
            className="mt-auto sm:h-10 sm:text-xs bg-transparent text-white border border-gray-5 hover:bg-gray-4 hover:border-gray-4"
            size="sm"
            to={ctas?.[1]?.url}
          >
            {ctas?.[1]?.text}
          </Button>
        </div>

        <div
          className={clsx(
            'flex flex-col items-center rounded-[20px] p-8 pb-10 lg:rounded-2xl sm:order-1 sm:p-5',
            themeClassNames[style1]
          )}
        >
          <Heading2
            size="sm"
            tag="h3"
            className="font-medium leading-snug sm:text-2xl"
            theme="black"
          >
            {rightTitle}
          </Heading2>
          <p className="mt-3 mb-7 text-center leading-snug  sm:mb-5 sm:text-base">
            {rightDescription}
          </p>
          <Button
            className="mt-auto sm:h-10 sm:text-xs bg-black text-white hover:bg-primary/25"
            size="sm"
            to={ctas?.[0]?.url}
          >
            {ctas?.[0]?.text}
          </Button>
        </div>
      </div>
    </div>

    <img
      className="absolute top-1/2 left-1/2 min-w-[1920px] -translate-x-1/2 -translate-y-1/2"
      src={bg}
      loading="lazy"
      alt=""
      aria-hidden
    />
  </section>
)};

CTA2.propTypes = {
  title: PropTypes.string,
  leftTitle: PropTypes.string,
  leftDescription: PropTypes.string,
  leftButtonLink: PropTypes.shape({
    to: PropTypes.string,
    target: PropTypes.string,
  }),
  leftButtonText: PropTypes.string,
  rightTitle: PropTypes.string,
  rightDescription: PropTypes.string,
  rightButtonLink: PropTypes.shape({
    to: PropTypes.string,
    target: PropTypes.string,
  }),
  rightButtonText: PropTypes.string,
  style0: PropTypes.oneOf(Object.keys(themeClassNames)),
  style1: PropTypes.oneOf(Object.keys(themeClassNames))
};

CTA2.defaultProps = {
  title: TITLE,
  leftTitle: LEFT_TITLE,
  leftDescription: LEFT_DESCRIPTION,
  leftButtonLink: LINKS.docker,
  leftButtonText: LEFT_BUTTON_TEXT,
  rightTitle: RIGHT_TITLE,
  rightDescription: RIGHT_DESCRIPTION,
  rightButtonLink: LINKS.getStarted,
  rightButtonText: RIGHT_BUTTON_TEXT,
  style0: 'pink',
  style1: 'blue',
};

